import React, { Fragment } from 'react';
import logo from "../../assets/square-network-surface-reseller.png"
import "../../components/footer.css";
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';



const Footer = () => {
const [year, setYear] = useState(new Date().getFullYear());

useEffect(() => {
setYear(new Date().getFullYear());
}, []);

return (

<Fragment>
<footer className="footer-section">
<div className="container">
<div className="footer-cta pt-5 pb-5">
<div className="row">
<div className="col-xl-4 col-md-4 mb-30">
<div className="single-cta">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#ff6013" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" /></svg>
<div className="cta-text">
<h4>Find us</h4>
<span>
Upstairs, ICICI Bank, Old No-25, New, 49, Royapettah High Rd, Royapettah, Chennai, Tamil Nadu 600014
</span>

</div>
</div>
</div>

<div className="col-xl-4 col-md-4 mb-30">
<div className="single-cta">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#66f769" d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" /></svg>
<div className="cta-text">
<h4>Call us</h4>
<span>+91 98409 87432</span>
</div>
</div>
</div>

<div className="col-xl-4 col-md-4 mb-30">
<div className="single-cta">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ff5555" d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" /></svg>
<div className="cta-text">
<h4>Mail us</h4>
<span>info@squarenet.in</span>
</div>
</div>
</div>
</div>
</div>

<div className="footer-content pt-5 pb-5">
<div className="row">
<div className="col-xl-4 col-lg-4 mb-50">
<div className="footer-widget">
<div className="footer-logo">
<a href="/"><img src={logo} className="img-fluid" alt="Square Network Solutions Microsoft Surface Authorized Reseller" /></a>
</div>

<div className="footer-text">
<p>Success in today's world is all about the power of connections! Whether you're an entrepreneur, a professional, or looking to expand your business, networking opens doors to new opportunities, partnerships, and growth. </p>
</div>

</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-6 mb-30">
<div className="footer-widget">
<div className="footer-widget-heading">
<h3>Useful Links</h3>
</div>
<ul>
<li><a href="/">Home</a></li>
<li><a href="/">Product</a></li>


<li><a href="/">services</a></li>
<li><a href="https://squarenet.in/contact">Contact</a></li>
<li><a href="https://squarenet.in/about">About us</a></li>
<li><a href="https://squarenet.in/success-stories">Success Stories</a></li>

</ul>
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-6 mb-50">
<div className="footer-widget">
<div className="footer-widget-heading">
<h3>Subscribe</h3>
</div>
<div className="footer-text mb-25">
<p>Don't miss to subscribe to our new feeds.</p>
</div>

<div className='row fot_icon'>
<div className='col-md-2 col-sm-4'>
<Link to="https://www.linkedin.com/company/squarenet/"> 
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#0000ff" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg> 
</Link>
</div>
<div className='col-md-2 col-sm-4'>
<Link to="https://www.youtube.com/@squarenetwork-1">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#ff0000" d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>
</Link>
</div>
<div className='col-md-2 col-sm-4'>
<Link to="https://www.instagram.com/square_network_solutions/">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#ff80c0" d="M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"/></svg>
</Link>
</div>
<div className='col-md-2 col-sm-4'> 
<Link to="https://www.facebook.com/Squarenetworksolutions">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#0080ff" d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"/></svg>
</Link>
</div>
<div className='col-md-2 col-sm-4'> 
<Link to="https://x.com/square_net1">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#000000" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
</Link>
</div>
</div>

</div>
</div>
</div>
</div>
</div>
<div className="copyright-area">
<div className="container">
<div className="row">
<div className="col-xl-6 col-lg-6 text-center text-lg-left">
<div className="copyright-text">

<div className="pt-lg-10  footer ">
{/* ... other code ... */}
<p>{`Copyright ©  ${year}. All Rights Reserved.`}
<a href="https://squarenet.in/"> Square Network Solution </a>
</p>
{/* ... other code ... */}
</div>

{/* <p>Copyright &copy; 2018, All Right Reserved </p> */}

</div>
</div>

<div className="col-xl-6 col-lg-6 d-none d-lg-block text-right">
<div className="footer-menu">
<ul>
<li><a href="https://squarenet.in/">Home</a></li>
<li><a href="#">Terms</a></li>
<li><a href="#">Privacy</a></li>
<li><a href="#">Policy</a></li>
<li><a href="https://squarenet.in/contact">Contact</a></li>
</ul>
</div>
</div>
</div>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>

<div>
<a className="btn-whats pulse" href="https://api.whatsapp.com/send?phone=919840987432&text=Hello, I came across your website and was wondering if you could kindly offer your services for our project." target="_blank">
<i className="fa fa-whatsapp"></i></a>
</div>
</div>
</div>

</footer>



</Fragment>
)
}

export default Footer